import TagManager from 'react-gtm-module';

const useGtmHook = () => {
  const gtmEvent = (eventName, eventData) => {
    if (eventData) {
      TagManager.dataLayer({
        dataLayer: {
          event: eventName,
          ...eventData,
        },
      });
      return;
    }

    TagManager.dataLayer({
      dataLayer: {
        event: eventName,
      },
    });
  };

  const gtmStepEvent = (eventName, stepLabel, eventData) => {
    TagManager.dataLayer({
      dataLayer: {
        event: eventName,
        step_label: stepLabel,
        ...eventData,
      },
    });
  };

  // const gtmFund = (eventName) => {
  //   TagManager.dataLayer({
  //     dataLayer: {
  //       event: eventName,
  //       fund: fundObject,
  //     },
  //   });
  // };

  return {
    gtmEvent,
    gtmStepEvent,
  };
};

export default useGtmHook;
